import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getAll.operation = 'READ';
export function getAll(query) {
    return get(`${API_URL}/activities`, { getData: query }).then(r => r.items);
}
